var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 129.26",
    style: {
      fill: "inherit",
      height: 72,
      padding: 8
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:inherit;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.47,81.14c1.71,3.28,4.69,5.1,8.08,6.27a46.35,46.35,0,0,0,31,0c3.33-1.16,6.28-3,8-6.39,4.85.54,9.72,1,14.57,1.65,5.68.78,10.09,3.81,13.57,8.26a42.17,42.17,0,0,1,8,17.44,10.38,10.38,0,0,1-4.2,11A32.89,32.89,0,0,1,105,124.21c-9,2.65-18.15,3.74-27.41,4.41a241,241,0,0,1-39.3-.34c-9.19-.84-18.33-2-27-5.38a33,33,0,0,1-6.36-3.29c-4.26-2.84-5.66-7-4.54-11.88A46.25,46.25,0,0,1,7.15,92.31c4.49-6.67,10.92-9.74,18.73-10.37C29.38,81.66,32.88,81.41,36.47,81.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.22,31.1c0,.48,0,1,0,1.44a4.84,4.84,0,0,0,1,3.79c.79.89,1,2.46,1.09,3.75a20.38,20.38,0,0,1-1.71,10,6.08,6.08,0,0,1-1.46,2.44c-2.16,1.6-2.78,4-3.85,6.25A46.29,46.29,0,0,1,74.37,74.6c-9.46,7.8-20.23,7.58-29.4-.55A49.69,49.69,0,0,1,32.26,55.49a10,10,0,0,0-1.46-2A17.49,17.49,0,0,1,28.87,51a19.57,19.57,0,0,1-2-12.09,18,18,0,0,1,1.48-3.44,4.52,4.52,0,0,0,.41-1.75,39.49,39.49,0,0,1,2.17-15.25C35,7.65,43.05,1.82,54.38.4a40.55,40.55,0,0,1,15.4.74C81.38,4.19,88,11.92,90.46,23.48c.27,1.3.45,2.62.59,3.95s.14,2.44.2,3.67Zm-11.58-.21a11,11,0,0,1-1.26-.55,15.76,15.76,0,0,0-12-2.25A32,32,0,0,1,49,27.31c-4-1.39-7.13-.24-9.82,2.89A21.75,21.75,0,0,0,34.93,39c-2.09.13-2.7.67-2.94,2.8a14.11,14.11,0,0,0,1.44,8.07c.65,1.3,1.47,2.38,3.18,2.08.27.73.5,1.37.76,2,2.89,7.15,6.81,13.53,13.46,17.81,6,3.82,12.08,3.92,18,.14A31.88,31.88,0,0,0,75,66.62c3.9-4.19,6.44-9.22,8.52-14.41a6.32,6.32,0,0,0,2.75-2,12.88,12.88,0,0,0,1.61-8.93c-.33-1.92-1-2.35-3-2.05a17,17,0,0,0-6-10.89Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/male.566b8abe35a0399cd3bae0fe21b10c5a.svg";
export { ForwardRef as ReactComponent };